module.exports = __webpack_public_path__ + "img/student_24.7de9303b.png";